import { render, staticRenderFns } from "./CreateCompanyForm.vue?vue&type=template&id=1fc952b8&scoped=true&"
import script from "./CreateCompanyForm.vue?vue&type=script&lang=js&"
export * from "./CreateCompanyForm.vue?vue&type=script&lang=js&"
import style0 from "./CreateCompanyForm.vue?vue&type=style&index=0&id=1fc952b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fc952b8",
  null
  
)

export default component.exports